<div class="payment-advise-container">
  <div class="payment-method">
    <ng-container
      *ngIf="paymentMethod.code === PAYMENT_METHOD_CODES.PREPAID; else payAtDestination"
    >
      <mb-badge class="payment-method__badge">
        <mb-icon class="icon" icon="bank-credit-card"></mb-icon>
        <span class="text">{{ paymentMethod.description }}</span>
      </mb-badge>
      <payment-advise-info
        [isExperts]="isExperts"
        [isCurrencyUSD]="isCurrencyUSD"
        [rate]="inputRate"
        [isArgentina]="isArgentina"
      ></payment-advise-info>
    </ng-container>
    <ng-template #payAtDestination>
      <mb-badge class="payment-method__badge">
        <mb-icon class="icon" icon="pay-at-destination"></mb-icon>
        <span class="text">{{ paymentMethod.description }}</span>
      </mb-badge>
      <payment-advise-info
        [rate]="inputRate"
        [isArgentina]="isArgentina"
      ></payment-advise-info>
    </ng-template>
  </div>
  <charges
    [rate]="inputRate"
    [ngClass]="{ 'with-is-economic': inputRate.isEconomic }"
  ></charges>
</div>
